import { createContext } from 'react'

export const TrackingContext = createContext(null)
